{
  "title": "QC Checkpoint Master",
  "subtitle": "Reusable inspection checklists for any industry or business — attach checkpoints once here, then require them per material or globally in Process Configuration.",
  "addTemplate": "New Checkpoint Template",
  "view": "View",
  "edit": "Edit",
  "delete": "Delete",
  "table": {
    "name": "Template Name",
    "checkpoints": "Checkpoints",
    "default": "Default",
    "status": "Status",
    "actions": "Actions"
  },
  "form": {
    "name": "Template Name",
    "status": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "default": "Set as Default Template",
    "defaultHelper": "This will become the template used for every QC-required material that doesn't have its own template mapped in Material Master — any other template currently marked default will be unmarked.",
    "checkpoints": "Checkpoints",
    "checkpointName": "Checkpoint Name",
    "description": "Description",
    "inspectionType": "Inspection Type",
    "valueType": "Value Type",
    "comparisonOperator": "Comparison",
    "standardValue": "Standard Value",
    "toleranceValue": "Tolerance (±)",
    "toleranceHelper": "Used with \"Equal To\" — the acceptable +/- deviation from the standard value.",
    "criteria": "Pass Criteria",
    "mandatory": "Mandatory",
    "mustBe": "must be",
    "noCheckpoints": "This template has no checkpoints defined.",
    "addCheckpoint": "Add Checkpoint"
  },
  "inspectionTypes": {
    "Visual": "Visual",
    "Measurement": "Measurement",
    "Functional": "Functional",
    "Safety": "Safety",
    "Documentation": "Documentation"
  },
  "valueTypes": {
    "YesNo": "Yes / No",
    "Value": "Value"
  },
  "comparisonOperators": {
    "LessThan": "Less Than",
    "GreaterThan": "Greater Than",
    "EqualTo": "Equal To",
    "LessThanOrEqual": "Less Than or Equal",
    "GreaterThanOrEqual": "Greater Than or Equal"
  },
  "discardChanges": "Discard Changes",
  "close": "Close",
  "saveTemplate": "Save Template",
  "deleteTemplate": {
    "message": "This checkpoint template will be permanently removed."
  }
}
